/** Accept historical numeric values, but keep catalogue/snapshot values as strings. */
export function securityKccNumber(value: unknown): string | undefined {
    const text = typeof value === 'number' && Number.isSafeInteger(value) ? String(value)
        : typeof value === 'string' ? value.trim() : '';
    return /^\d{1,10}$/.test(text) && Number(text) > 0 ? text : undefined;
}
